import { RefObject, useRef, useState } from "react";
import { useDidMount } from "rooks";

export const useIsWidgetVisible = (): [
  RefObject<HTMLDivElement>,
  boolean | null,
] => {
  const intersectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState<boolean | null>(null);

  useDidMount(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.intersectionRatio >= 0.1),
      {
        root: null,
        threshold: 0.1,
      },
    );

    const currentRef = intersectionRef.current;

    if (!currentRef) {
      return;
    }

    const timeOutId = setTimeout(() => {
      observer.observe(currentRef);
    }, 500);

    return () => {
      clearTimeout(timeOutId);
      observer.unobserve(currentRef);
    };
  });

  return [intersectionRef, isVisible];
};
